import React from "react";
import { ContractNumber } from "../../ServicePanel/styles";
import { DotIcon } from "../../ServicePanel/card-icons";
import { FantasyNameContractBadgeContainer } from "../../styles";

export function ContractNumberBadge({ contractNumber, event = false }) {
  return (
    <ContractNumber event={event}>
      <DotIcon /> {contractNumber}
    </ContractNumber>
  );
}

export function FantasyNameAndContractBadge({ contractNumber, fantasyname }) {
  return (
    <FantasyNameContractBadgeContainer>
      <span>{fantasyname.toLowerCase()}</span>
      <ContractNumberBadge contractNumber={contractNumber} />
    </FantasyNameContractBadgeContainer>
  );
}
